
export const CUSTOM_ROUTE_DESKTOP_MAP = {
  map: 'map',
  more: 'more',
} as const;